<form [formGroup]="formGroup" class="form">
  <div *ngIf="title" class="form-sub-title">
    {{ title }}
  </div>
  <mat-form-field appearance="outline">
    <input
      matInput
      [matDatepicker]="picker1"
      formControlName="answer"
      placeholder="{{ placeholder }}"
      (input)="answered($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>
</form>
